import { Map } from 'immutable';

import { getFirstValue } from '../../../taxonomy/properties';
import { getSize } from '../../../iterable/getSize';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { EMPTY } from '../../../../constants';
import { EBAY } from '../../../../constants/channels';

export function itemSpecifics({ preview, property }) {
  const name = property.get('name');
  const path = property.get('path');
  const value = preview.get(name, EMPTY.SET);

  return {
    payload: Map({
      type: path === 'properties'
        ? OPERATIONS[EBAY].ITEM_SPECIFICS.UPDATE
        : OPERATIONS[EBAY].PRODUCT_DETAILS.UPDATE,
      value: Map({
        [name]: Map({
          value: getSize(value) === 1 && getFirstValue(value) === null
            ? EMPTY.LIST
            : value.toList(),
        }),
      }),
    }),
  };
}
